import { DiagnosesObject } from "../CaseReport.types";

const ClinicalInformation = ({
  diagnoses = [] as DiagnosesObject[],
}: {
  diagnoses: DiagnosesObject[];
}) => {
  return (
    <section className="PrintReportSection">
      <h2 className="PrintReportSection__header">Clinical Information:</h2>
      <table className="PrintReportSection__table">
        <tbody>
          {diagnoses.map(
            (diag, index) =>
              diag.specimen && (
                <tr key={index}>
                  <td className="PrintReportSection__table--removeWrap">
                    {diag.specimen.name}.
                  </td>
                  {diag.specimen.clinical_history && (
                    <td>{diag.specimen.clinical_history.toUpperCase()}</td>
                  )}
                </tr>
              )
          )}
        </tbody>
      </table>
    </section>
  );
};

export default ClinicalInformation;
